/* Lazy hover maps, shared by cw-locations.liquid and cw-sales-partners.liquid.
 *
 * Contract: any element with data-cw-map="<url-encoded maps query>" gets a
 * Google embed built into it the first time its PARENT is hovered or focused.
 * The parent is the card; nothing else is assumed about the markup, which is
 * what lets locations and partners share this file.
 *
 * Built on first hover, never on load: /pages/partners renders eight location
 * cards plus eleven partner cards, and nineteen Google embeds at page load is
 * the same weight mistake the gallery had (capped to 4 there for the same
 * reason). Touch devices get no hover, so they get no iframe at all — both
 * sections keep a visible link for that case.
 *
 * Loaded with defer by both sections, so this runs once after the whole DOM is
 * parsed and sees every card regardless of section order. The guard below keeps
 * a second <script> tag from binding everything twice.
 */
(function () {
  if (window.__cwHoverMap) return;
  window.__cwHoverMap = 1;

  var wraps = document.querySelectorAll('[data-cw-map]');
  if (!wraps.length) return;
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

  function build(wrap) {
    if (wrap.dataset.cwLoaded) return;
    wrap.dataset.cwLoaded = '1';
    var q = wrap.getAttribute('data-cw-map');
    if (!q) return;
    /* Street-level by default. A card with no street address passes a wider
       zoom via data-cw-zoom — "Dänemark" at z=13 geocodes to a random village
       rather than the country, which is worse than no map. */
    var z = wrap.getAttribute('data-cw-zoom') || '13';
    var f = document.createElement('iframe');
    f.src = 'https://maps.google.com/maps?q=' + q + '&z=' + encodeURIComponent(z) + '&output=embed';
    /* Deliberately NOT loading="lazy". The iframe is created inside a
       max-height:0 / overflow:hidden wrapper, so at insert time it has no
       visible box and the lazy loader can defer the fetch indefinitely — the
       panel then slides open empty, which is what "map is gone" looked like.
       Building only on hover is already the deferral; lazy just adds a race. */
    f.setAttribute('tabindex', '-1');
    f.setAttribute('aria-hidden', 'true');
    wrap.insertBefore(f, wrap.firstChild);
  }

  wraps.forEach(function (wrap) {
    var card = wrap.parentElement;
    if (!card) return;
    card.addEventListener('mouseenter', function () { build(wrap); }, { once: true });
    card.addEventListener('focusin', function () { build(wrap); }, { once: true });
  });
})();
